import script from "./PlantillaColla.vue?vue&type=script&setup=true&lang=js"
export * from "./PlantillaColla.vue?vue&type=script&setup=true&lang=js"

import "./PlantillaColla.vue?vue&type=style&index=0&id=65874855&lang=css"

const __exports__ = script;

export default __exports__